import { render, staticRenderFns } from "./DialogueList.vue?vue&type=template&id=72658b56&scoped=true&"
import script from "./DialogueList.vue?vue&type=script&lang=js&"
export * from "./DialogueList.vue?vue&type=script&lang=js&"
import style0 from "./DialogueList.vue?vue&type=style&index=0&id=72658b56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72658b56",
  null
  
)

export default component.exports